import { useMemo } from 'react';
import { isInstagramBrowser, isTikTokBrowser } from './detectDevice';

export const useIsProfileReferral = (): boolean => {
  // Determine a user who has come from a profile we are checking
  // navigator.userAgent to see if it is an Instagram or TikTok in-app browser.
  const isProfileReferral: boolean = useMemo(() => {
    return isInstagramBrowser() || isTikTokBrowser();
  }, []);
  return isProfileReferral;
};
